"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorageBackendDataProvider = useStorageBackendDataProvider;
const useStorageListColumns_1 = require("../../ui/hooks/useStorageListColumns");
const useStorageList_1 = require("./useStorageList");
function useStorageBackendDataProvider(entityName, mapEntityFilterData, columns) {
    return (request) => {
        let response;
        const requestToUse = {
            filter: mapEntityFilterData(request.filterData),
            orderBy: request.sortColumnKey === '_updated'
                ? []
                : [{ column: request.sortColumnKey, desc: request.sortColumnDesc }],
            orderByUpdatedDesc: request.sortColumnKey === '_updated' ? request.sortColumnDesc : undefined,
            limit: request.limit,
            offset: request.offset,
        };
        const listResponse = (0, useStorageList_1.useStorageList)(entityName, columns ? undefined : requestToUse);
        const listColumnsResponse = (0, useStorageListColumns_1.useStorageListColumns)(entityName, columns ? requestToUse : undefined, columns);
        if (columns) {
            response = listColumnsResponse;
        }
        else {
            response = listResponse;
        }
        return {
            data: response.data
                ? {
                    filteredRowCount: response.data.total,
                    rows: response.data.rows,
                }
                : undefined,
            error: response.error,
            isLoading: response.isLoading,
            reload: response.mutate,
        };
    };
}
